import React from "react";

const activities = [
 
    {
    title: "Claude Startup Program",
    subtitle: "Selected Startup · Ongoing",
    desc: "Building Magnet Labs with access to Anthropic's Claude models and startup support resources.",
    image: "/photos/claudelogo.png",
  },
  {
    title: "Neo4j Startup Program",
    subtitle: "Selected Startup · Ongoing",
    desc: "Magnet Labs was accepted into the Neo4j Startup Program for graph database support and resources.",
    image: "/photos/neo4jlogo.png",
  },
   {
    title: "İTÜ Çekirdek Acceleration Program",
    subtitle: "Selected Startup · Ongoing",
    desc: "Accelerating Magnet Labs with focus on product-market fit, scaling, and investment readiness.",
    image: "/photos/itucekirdeklogo.png",
  },
    {
    title: "Board Member — Bahçeşehir Startup Union",
    subtitle: "2025 – Present",
    desc: "Contributing to startup community and organizing entrepreneurship initiatives.",
    image: "/photos/society.png",
  },
   {
    title: "Ethereum Global Istanbul Hackathon",
    subtitle: "Awarded by Worldcoin Foundation",
    desc: "Built myDMentor and implemented Ethereum-based integrations.",
    image: "/photos/ethglobal.png",
  },
   {
    title: "Tech Istanbul Entrepreneurship School",
    subtitle: "Selected among 300+ applicants",
    desc: "Startup and innovation program focused on building scalable products.",
    image: "/photos/techistanbul.png",
  },
  {
    title: "IBM SkillsBuild AI4Future",
    subtitle: "Advanced Level · Ongoing",
    desc: "Advanced AI program covering machine learning and deep learning with hands-on projects.",
    image: "/photos/ibm.png",
  },
 
 
 

];

export default function ActivitiesSection() {
  return (
    <section id="activities" className="w-full bg-[#0d0d0d] py-16">
      <div className="px-6 md:px-10">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Activities and Hackathons
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 px-6 sm:grid-cols-2 md:px-10 lg:grid-cols-3">
        {activities.map((a) => (
          <div
            key={a.title}
            className="rounded-[28px] bg-white/[0.03] px-7 py-8 md:px-8 md:py-9"
          >
            <div className="flex items-start gap-4">
              <img
                src={a.image}
                alt=""
                draggable={false}
                className="h-16 w-16 shrink-0 object-contain"
              />
              <div className="min-w-0 pt-0.5">
                <h3 className="text-lg font-semibold tracking-tight text-neutral-200">
                  {a.title}
                </h3>
                <div className="mt-1 text-[13px] text-neutral-500">{a.subtitle}</div>
              </div>
            </div>

            <p className="mt-4 text-[14px] leading-relaxed text-neutral-400">
              {a.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
